module.exports = __webpack_public_path__ + "static/banner-background-031692b41e533ca9afe9f6f2d64f5199.svg";